import Api from '@/services/api.js'

export default {
  //BATCHES
  addBatch(batch) {
    return Api.post('allocations/batch', batch)
  },
  updateBatch(batch) {
    var id = batch.id
    return Api.put(`allocations/batch/${id}`, batch)
  },
  deleteBatch(batch) {
    var id = batch.id
    return Api.delete(`allocations/batch/${id}`)
  },
  getBatches(payload) {
    return Api.post('allocations/batch/get', payload)
  },
  updateBatchField(payload) {
    return Api.put(`allocations/batch/${payload.id}/${payload.field}`, payload)
  },
  commitBatch(batch) {
    var id = batch.id
    return Api.post(`allocations/batch/commit/${id}`)
  },
  getBatchLines(batch) {
    var id = batch.id
    return Api.get(`allocations/batch/${id}/lines`)
  },
  getBatchLinesByDate(date) {
    return Api.get(`allocations/batchLines/date/${date}`)
  },
  createBatchLine(batchId, line) {
    return Api.post(`allocations/batch/${batchId}/line`, line)
  },
  deleteBatchLine(line) {
    var id = line.id
    return Api.delete(`allocations/batchLine/${id}`)
  },
  updateBatchLine(line) {
    var id = line.id
    return Api.put(`allocations/batchLine/${id}`, line)
  },
  getBatchLinesByBatchIds(body) {
    return Api.post('allocations/batchLines/get', body)
  },
  updateBatches(batches) {
    return Api.patch(`allocations/batches`, batches)
  },

  //ALLOCATIONS
  addAllocation(allocation) {
    return Api.post('allocations/add', allocation)
  },
  updateAllocation(allocation) {
    return Api.put(`allocations/${allocation.id}`, allocation)
  },
  getAllocations(payload) {
    return Api.post(`allocations/get`, payload)
  },
  matchDockets() {
    return Api.post(`allocations/matchDockets`)
  },
  // getConfirmedAllocations() {
  //     return Api.get('allocations/confirmed')
  // },

  // getUnConfirmedAllocations() {
  //     return Api.get('allocations/unconfirmed')
  // },
  voidAllocation(payload) {
    return Api.put(`allocations/void/${payload.id}`, payload)
  },
  deleteAllocation(allocation) {
    return Api.delete(`allocations/${allocation}`)
  },

  getFinalisedAllocations() {
    return Api.get('allocations/finalised')
  },

  importAllocations(file) {
    return Api.post('allocations/import', file)
  },
  getAllocationsByIds(body) {
    return Api.post('allocations/lines/get', body)
  }
}
